<mat-dialog-content id="warning" tabindex="0" role="main">
    <h3 id="warningHeader" class="warningText" translate>WARNING</h3>
    <div class="warningText" translate>There are unsaved changes on this page.</div>
    <div style="margin-top:30px;" translate>Click OK to continue and lose the unsaved changes.</div>
    <div style="margin-top:15px;" translate>Click Cancel to return to the page.</div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div style="position: absolute; right:0px;">
        <tyl-button image="save black.png" label="OK" (clickEvent)="leavePage(true)"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="leavePage(false)"></tyl-button>
    </div>
</mat-dialog-actions>